import { number, string, shape } from 'prop-types'

export default shape({
  category:   string,
  created_at: number,
  data:       number,
  days:       number,
  period:     string,
  reason:     string,
  source:     string,
  year:       number
})
